(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./notificationNormalization", "./notificationGetters"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./notificationNormalization"), require("./notificationGetters"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.notificationNormalization, global.notificationGetters);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _notificationNormalization, _notificationGetters) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.keys(_notificationNormalization).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _notificationNormalization[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _notificationNormalization[key];
      }
    });
  });
  Object.keys(_notificationGetters).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _notificationGetters[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _notificationGetters[key];
      }
    });
  });
});